import React, { useState } from 'react';
import {
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  ELEMENT_PARAGRAPH,
  focusEditor,
  useEventPlateId,
  usePlateEditorState,
  toggleNodeType,
  findNode,
} from '@udecode/plate';

import ToolbarDropdown, { ToolbarDropdownButton } from './ToolbarDropdown';

const headingLabels = {
  [ELEMENT_PARAGRAPH]: 'Paragraph',
  [ELEMENT_H1]: 'Heading 1',
  [ELEMENT_H2]: 'Heading 2',
  [ELEMENT_H3]: 'Heading 3',
  [ELEMENT_H4]: 'Heading 4',
  [ELEMENT_H5]: 'Heading 5',
  [ELEMENT_H6]: 'Heading 6',
};

const types = [
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  ELEMENT_PARAGRAPH,
];

const HeadingDropdown = ({ id, ...props }) => {
  const [open, setOpen] = useState(false);
  const editor = usePlateEditorState(useEventPlateId(id));
  const [activeElement] = findNode(editor, { match: { type: types } }) || [];
  const active = activeElement ? activeElement.type : ELEMENT_PARAGRAPH;

  const setHeading = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    toggleNodeType(editor, { activeType: type });
    focusEditor(editor);
    setOpen(false);
  };

  const show = () => {
    setOpen(true);
  };

  const dismiss = () => {
    setOpen(false);
  };

  const trigger = (
    <ToolbarDropdownButton
      className="toolbar-dropdown__button"
      showIcon
      {...props}
    >
      {headingLabels[active]}
    </ToolbarDropdownButton>
  );

  return (
    <ToolbarDropdown
      isOpen={open}
      show={show}
      dismiss={dismiss}
      DropdownButton={trigger}
      tooltipName="Set heading level"
      className="plate-toolbar__dropdown toolbar-dropdown heading-dropdown"
    >
      <button
        className="button--unstyled button--editor-menu"
        onClick={(e) => setHeading(e, ELEMENT_H1)}
      >
        <h1>Heading 1</h1>
      </button>
      <button
        className="button--unstyled button--editor-menu"
        onClick={(e) => setHeading(e, ELEMENT_H2)}
      >
        <h2>Heading 2</h2>
      </button>
      <button
        className="button--unstyled button--editor-menu"
        onClick={(e) => setHeading(e, ELEMENT_H3)}
      >
        <h3>Heading 3</h3>
      </button>
      <button
        className="button--unstyled button--editor-menu"
        onClick={(e) => setHeading(e, ELEMENT_H4)}
      >
        <h4>Heading 4</h4>
      </button>
      <button
        className="button--unstyled button--editor-menu"
        onClick={(e) => setHeading(e, ELEMENT_H5)}
      >
        <h5>Heading 5</h5>
      </button>
      <button
        className="button--unstyled button--editor-menu"
        onClick={(e) => setHeading(e, ELEMENT_H6)}
      >
        <h6>Heading 6</h6>
      </button>
      <button
        className="button--unstyled button--editor-menu"
        onClick={(e) => setHeading(e, ELEMENT_PARAGRAPH)}
      >
        Paragraph
      </button>
    </ToolbarDropdown>
  );
};

export default HeadingDropdown;
